import ImpersonateAlert from "./ImpersonateAlert";

export default ImpersonateAlert;
